import * as angular from "angular";
import {MatchDetailsController} from "./match-details.controller";
const templateUrl = require("./match-details.html");

export const matchDetails: angular.IDirective = {
    templateUrl: templateUrl,
    controller: MatchDetailsController,
    controllerAs: "vm",
    bindToController: true,
    scope: {
        onSchoolUnmatch: "<"
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/match-details/match-details.ts